import { connect } from '@vfde-sails/core';
import * as mapDispatch from '../App/action';
import {
    State,
    mapStateToProps,
} from '../App/selector';
import {
    AppId,
    Kip1000CableMax,
    TariffCardId,
} from '../../enums/elementId';
import {
    mountOptionPicker,
    updateTariffPickerValuesByProvicer,
} from '../../components/optionPicker';
import {
    addBenefitListTooltipTrackingEvent,
    mountVerticalList,
    updateBenefitListFootnoteLinks,
} from '../../components/unorderedVerticalList';
import { mountHorizontalList } from '../../components/unorderedHorizontalList';
import { getUpdateFlags } from './update';
import { getLinkListItems } from '../../util/components/horizontalList.util';
import { getBenefitListProps } from '../../util/components/verticalList.util';
import {
    getAvailableTariffBenefits,
    isPlaystationPromoActive,
} from '../../util/cms';
import { setElementVisibility } from '../../util/visibility';
import { updateSeal } from '../../util/seal';
import { KIP_500_BV_12 } from '../../constants';

type Actions = typeof mapDispatch;

function container (state: State, actions: Actions) {
    const tariffPicker = mountOptionPicker(TariffCardId.TARIFF_PICKER, (value: string) =>
        actions.setSelectedTariffId(value));

    const tariffBenefits = mountVerticalList(TariffCardId.TARIFF_BENEFITS);
    const tariffLinks = mountHorizontalList(AppId.LINKS_LIST);

    return {
        getDerivedStateFromProps (newState: State, oldState: State) {
            const {
                selectedTariffId,
                availableTariffs,
                selectedTariff,
                customer,
                selectedTVProduct,
                marketability,
                isAvailabilityChecked,
                isContentEnabled,
                providerType,
                isFriendsAndFamily,
                isYoung,
            } = newState;
            const update = getUpdateFlags(newState, oldState);
            const availableIds = availableTariffs.map(tariff => tariff.id);
            const excludedIds = Object.values(Kip1000CableMax);

            if (update.provider && providerType) {
                updateTariffPickerValuesByProvicer(tariffPicker, providerType);
            }

            if (update.tariffPicker || isPlaystationPromoActive()) {
                updateSeal(selectedTariffId, isContentEnabled);
                tariffPicker?.setValue(selectedTariffId);
                const idsToEnable = availableIds.filter((id: any)=> !excludedIds.includes(id));

                if (isPlaystationPromoActive() && (isFriendsAndFamily || isYoung)) {
                    tariffPicker?.enableOptionsByValues(idsToEnable);
                    const enableSelectedTariff =
                Object.values(Kip1000CableMax).includes(selectedTariffId as Kip1000CableMax) ? KIP_500_BV_12 : selectedTariffId;
                    actions.setSelectedTariffId(enableSelectedTariff);
                }
                else {
                    tariffPicker?.enableOptionsByValues(availableIds);
                }
            }

            if (update.tariffBenefits) {
                const cmsBenefits = selectedTariff ? getAvailableTariffBenefits(
                    selectedTariff,
                    Boolean(marketability?.isSelfInstall),
                    Boolean(customer?.existingTvConnectId),
                    Boolean(selectedTVProduct) || !isAvailabilityChecked,
                ) : [];

                tariffBenefits?.update(getBenefitListProps(tariffBenefits, cmsBenefits));
                updateBenefitListFootnoteLinks(tariffBenefits);
                addBenefitListTooltipTrackingEvent(tariffBenefits, cmsBenefits);
            }

            update.tariffLinks && tariffLinks?.update(getLinkListItems(tariffLinks, selectedTariff));
            update.content && setElementVisibility(TariffCardId.TARIFF_BENEFITS_WRAPPER, isContentEnabled);
        },
    };
}

export default connect(mapStateToProps, mapDispatch)(container);
